__turbopack_context__.v({
  "btn": "TryAiSearch-module-scss-module__NEDfmq__btn",
  "btnText": "TryAiSearch-module-scss-module__NEDfmq__btnText",
  "divider": "TryAiSearch-module-scss-module__NEDfmq__divider",
  "label": "TryAiSearch-module-scss-module__NEDfmq__label",
  "list": "TryAiSearch-module-scss-module__NEDfmq__list",
  "query": "TryAiSearch-module-scss-module__NEDfmq__query",
  "root": "TryAiSearch-module-scss-module__NEDfmq__root",
});
